import { ConsumerPortalEnviromentConfig } from './model';
declare let require: any;
export const environment: ConsumerPortalEnviromentConfig = {
    production: false,
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    version: require('../../project.json').appVersion,
    uiUrl: 'https://qae-consumer-portal-ui.rentamation.com',
    apiUrl: 'https://qae-consumer-portal-api.rentamation.com/v1',
    loginApiUrl: 'https://qae-consumer-login-api.rentamation.com/v1',
    loginApiUrlInternal: 'https://qae-consumer-login-api.rentamation.com/v1',
    porPayScriptURL: 'https://dev-por-pay-ui.rentamation.com/main.js',
    gapiApiBaseUrl: 'https://api.pointofrental.com/v1_dev',
    envName: 'qae',
    adminJSUrl: 'https://qae-ecom-consumer-portal-admin.rentamation.com'
};
